import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "article" }
const _hoisted_2 = { class: "article-content max-w-5xl" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-center clear-both mt-rem4 sm:mt-rem5 mb-12"
}
const _hoisted_4 = {
  key: 1,
  class: "mt-12"
}
const _hoisted_5 = { class: "flex" }

import ModalCover from '@/components/ModalCover.vue'
import Footer from '@/components/Footer.vue'
import LanguageButtonStandalonePage from '@/blocks/languageButtonStandalonePage.vue'
import ContactForm from '../views/mainPage/ContactForm.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ArticleModalContent',
  props: {
    title: {},
    cover: {},
    coverOffset: {},
    contentStyle: {},
    noContactForm: { type: Boolean },
    languageButtonStickyHeight: {},
    languageButtonAlign: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_icon_back = _resolveComponent("icon-back")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LanguageButtonStandalonePage, {
      "sticky-height": __props.languageButtonStickyHeight,
      align: __props.languageButtonAlign
    }, null, 8, ["sticky-height", "align"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ModalCover, {
        image: __props.cover,
        coverOffset: __props.coverOffset,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.title), 1)
        ]),
        _: 1
      }, 8, ["image", "coverOffset"]),
      _createElementVNode("div", {
        class: "side-padded relative overflow-hidden p-rem3 pb-0 sm:pt-rem6 flex justify-center",
        style: _normalizeStyle(__props.contentStyle)
      }, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default"),
          (!__props.noContactForm)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(ContactForm, { mode: "compact" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.$t('article.bookAppointment')), 1)
                    ])
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4)),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_a_button, {
              class: "mt-rem1 mx-auto",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
              color: "black"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_icon_back, { size: 20 }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('article.back')), 1)
              ]),
              _: 1
            })
          ]),
          _createVNode(Footer)
        ])
      ], 4)
    ])
  ], 64))
}
}

})